import { version } from '../../../constants';

export const Version = (): JSX.Element => (
  <div className='c-version'>
    <p>Version: {version}</p>
  </div>
);
